import React from "react";
import { CalendarioIcon } from "components/icons/CalendarioIcon";
import { PrescricaoICon } from "components/icons/PrescricaoIcon";
import { SinaisIcon } from "components/icons/SinaisIcon";

export const AplicativoMobileTabs = () => {
  return (
    <div className="row row-cols-1 d-md-none">
      <div className="col d-flex flex-row bg-blue py-3">
        <div className="col-2" style={{ display: "contents" }}>
          <PrescricaoICon className="aplicativos-page__slider-icon-sm" />
        </div>
        <div className="col aplicativos-page__slider-sm">
          <p className="title">Sua Prescrição sempre com você</p>
          <p className="content">
            Acesso total à sua Prescrição e orientações de saúde de sua equipe
            médica
          </p>
        </div>
      </div>

      <div className="col d-flex flex-row bg-blue py-3">
        <div className="col-2" style={{ display: "contents" }}>
          <SinaisIcon className="aplicativos-page__slider-icon-sm" />
        </div>
        <div className="col aplicativos-page__slider-sm">
          <p className="title">Suas medidas e Sinais Vitais</p>
          <p className="content">
            Insira suas medidas como Pressão Arterial, Glicose, Peso e IMC,
            Temperatura e compartilhe com seu médico no prontuário ProntLife
          </p>
        </div>
      </div>

      <div className="col d-flex flex-row bg-blue py-3">
        <div className="col-2" style={{ display: "contents" }}>
          <CalendarioIcon className="aplicativos-page__slider-icon-sm" />
        </div>
        <div className="col aplicativos-page__slider-sm">
          <p className="title">Exame de Laboratório e Imagem</p>
          <p className="content">
            Digitalize ou tire fotos dos seus exames solicitados, assim seu
            médico poderá ter acesso na sua próxima consulta
          </p>
        </div>
      </div>
    </div>
  );
};
